module.exports = __webpack_public_path__ + "img/ikuta-san.220084b8.jpg";